//
//
//Dashboard_Graphs
//
//
//
//Displays validation metrics
//
//by plotting data 
//
//on graphs
//
//and displays graph details
//
//

import React from 'react';
import {Bar} from 'react-chartjs-2';
//import {Table} from 'react-bootstrap';
import { getValidationMetrics , getValidationMetrics_lvl2 } from '../components/UserFunctions'
import PropTypes from 'prop-types';


// const state = {
//   labels: ['Scene1', 'Scene2', 'Scene3',
//            'Scene4', 'Scene5'],
//   datasets: [
//     {
//       label: 'Value',
//       backgroundColor: '#CBFF68',
//       borderColor: '#464646',

//       borderWidth: 2,
//       data: []
//     }
//   ]
// }

export default class App extends React.Component {

  state = {
    recall:{
      labels: [],
      datasets: [
        {
        label: 'Value',
        backgroundColor: '#CBFF68',
        borderColor: '#464646',

        borderWidth: 2,
        data: []
        }
      ]
    },
    precision:{
      labels: [],
      datasets: [
        {
        label: 'Value',
        backgroundColor: '#CBFF68',
        borderColor: '#464646',

        borderWidth: 2,
        data: []
        }
      ]
    },
    f1_score:{
      labels: [],
      datasets: [
        {
        label: 'Value',
        backgroundColor: '#CBFF68',
        borderColor: '#464646',

        borderWidth: 2,
        data: []
        }
      ]
    },
    scenario: []

  };
//
    //Function called after component is mounted
    //
  componentDidMount(){
    // console.log(this.props.runid)

     this.props.level==="3"?
      getValidationMetrics().then(res => {
        console.log(res.data);
        if(res !== undefined){
        this.setState({

            recall:{
              labels: res.data.recall['label'],
              datasets: [
                {
                label: 'Value',
                backgroundColor: '#CBFF68',
                borderColor: '#464646',

                borderWidth: 2,
                // data: [res.data.data[0],0,0,0,0]
                data: res.data.recall['data']
                }
              ]
            },
            precision:{
              labels: res.data.precision['label'],
              datasets: [
                {
                label: 'Value',
                backgroundColor: '#CBFF68',
                borderColor: '#464646',

                borderWidth: 2,
                data: res.data.precision['data']
                }
              ]
            },
            f1_score:{
              labels: res.data.f1_score['label'],
              datasets: [
                {
                label: 'Value',
                backgroundColor: '#CBFF68',
                borderColor: '#464646',

                borderWidth: 2,
                data: res.data.f1_score['data']
                }
              ]
            },
            scenario: res.data.scenario

        })
      }
    })

    :
    //
    // Function to get validation metrics level 2 data
    //
    getValidationMetrics_lvl2().then(res =>{
      //console.log(res.data);
      if(res !== undefined){
      this.setState({

          recall:{
            labels: res.data.recall['label'],
            datasets: [
              {
              label: 'Value',
              backgroundColor: '#CBFF68',
              borderColor: '#464646',

              borderWidth: 2,
              // data: [res.data.data[0],0,0,0,0]
              data: res.data.recall['data']
              }
            ]
          },
          precision:{
            labels: res.data.precision['label'],
            datasets: [
              {
              label: 'Value',
              backgroundColor: '#CBFF68',
              borderColor: '#464646',

              borderWidth: 2,
              data: res.data.precision['data']
              }
            ]
          },
          f1_score:{
            labels: res.data.f1_score['label'],
            datasets: [
              {
              label: 'Value',
              backgroundColor: '#CBFF68',
              borderColor: '#464646',

              borderWidth: 2,
              data: res.data.f1_score['data']
              }
            ]
          },
          scenario: res.data.scenario

      })
    }

    })

    

  }

// const state = {
//   labels: ['Scene1', 'Scene2', 'Scene3',
//            'Scene4', 'Scene5'],
//   datasets: [
//     {
//       label: 'Value',
//       backgroundColor: '#CBFF68',
//       borderColor: '#464646',

//       borderWidth: 2,
//       data: []
//     }
//   ]
// }
// const state = {
//   labels: ['Scene1', 'Scene2', 'Scene3',
//            'Scene4', 'Scene5'],
//   datasets: [
//     {
//       label: 'Value',
//       backgroundColor: '#CBFF68',
//       borderColor: '#464646',

//       borderWidth: 2,
//       data: []
//     }
//   ]
// }

//
//Called when the component may be receiving new props
//
  UNSAFE_componentWillReceiveProps (newProps) {
    // console.log(newProps)
    if( this.props.level === "3" && newProps.run_id !== this.props.run_id) {
      var runid_json = {run_id:newProps.run_id}
//
// function to get validation metrics
//
      getValidationMetrics(runid_json).then(res => {
        // console.log(res.data);
        this.setState({

            recall:{
              labels: res.data.recall['label'],
              datasets: [
                {
                label: 'Value',
                backgroundColor: '#CBFF68',
                borderColor: '#464646',

                borderWidth: 2,
                // data: [res.data.data[0],0,0,0,0]
                data: res.data.recall['data']
                }
              ]
            },
            precision:{
              labels: res.data.precision['label'],
              datasets: [
                {
                label: 'Value',
                backgroundColor: '#CBFF68',
                borderColor: '#464646',

                borderWidth: 2,
                data: res.data.precision['data']
                }
              ]
            },
            f1_score:{
              labels: res.data.f1_score['label'],
              datasets: [
                {
                label: 'Value',
                backgroundColor: '#CBFF68',
                borderColor: '#464646',

                borderWidth: 2,
                data: res.data.f1_score['data']
                }
              ]
            },
            scenario: res.data.scenario

        })
    })
    }
  
    if( this.props.level === "2" && newProps.bench_id !== this.props.bench_id) {
      var benchid_json = {bench_id:newProps.bench_id}
//
// function to get validation metrics of level2
//
      getValidationMetrics_lvl2(benchid_json).then(res => {
        // console.log(res.data);
        this.setState({

            recall:{
              labels: res.data.recall['label'],
              datasets: [
                {
                label: 'Value',
                backgroundColor: '#CBFF68',
                borderColor: '#464646',

                borderWidth: 2,
                // data: [res.data.data[0],0,0,0,0]
                data: res.data.recall['data']
                }
              ]
            },
            precision:{
              labels: res.data.precision['label'],
              datasets: [
                {
                label: 'Value',
                backgroundColor: '#CBFF68',
                borderColor: '#464646',

                borderWidth: 2,
                data: res.data.precision['data']
                }
              ]
            },
            f1_score:{
              labels: res.data.f1_score['label'],
              datasets: [
                {
                label: 'Value',
                backgroundColor: '#CBFF68',
                borderColor: '#464646',

                borderWidth: 2,
                data: res.data.f1_score['data']
                }
              ]
            },
            scenario: res.data.scenario

        })
    })
    }
  }


  render() {
    // console.log(this.state)

    return (
      //
      // UI code
      //

      <div data-test = 'dashboardGraphsComponent' className="ibox-transparent">
        <div className="ibox-head">
          <div className="ibox-title">
            <font color="white">&nbsp;Validation Metrics (last 5 entries)</font>

          </div>
        </div>
        <div className="ibox-body">
          <div className="row">
            <div className="col-lg-4">
            {this.state.recall.labels !== undefined?
              <Bar
                data={this.state.recall}
                height={250}
                options={{
                  title:{
                    display:true,
                    text:'Recall (in %)',
                    fontSize:20
                  },
                  tooltips: {
                    callbacks: {
                        afterLabel: (t, d) => {
                            const index = parseInt(t.xLabel.split("_")[1]) - 1
                            return this.state.scenario[parseInt(index)]
                            }
                        }
                  },
                  scales:{
                    xAxes: [{
                      barThickness : 25
                  }],
                  yAxes: [{
                      ticks: {
                          beginAtZero:true,
                          min: 0,
                          max: 100
                      }
                    }]
                  },
                  legend:{
                    display:false
                  },
                  maintainAspectRatio: false,
                  // legend:{
                  //   display:true,
                  //   position:'right'
                  // }
                }}
              />
              :
              <div className="alert alert-secondary" role="alert">
                No data available
              </div>
            }
            </div>
            <div className="col-lg-4">
            {this.state.precision.labels !== undefined?
              <Bar
                data={this.state.precision}
                height={250}
                options={{
                  title:{
                    display:true,
                    text:'Precision (in %)',
                    fontSize:20
                  },
                  tooltips: {
                    callbacks: {
                        afterLabel: (t, d) => {
                            const index = parseInt(t.xLabel.split("_")[1]) - 1
                            return this.state.scenario[parseInt(index)]
                            }
                        }
                  },
                  scales:{
                    xAxes: [{
                      barThickness : 25
                    }],
                    yAxes: [{
                      ticks: {
                          beginAtZero:true,
                          min: 0,
                          max: 100
                      }
                    }]
                  },
                  legend:{
                    display:false
                  },
                  maintainAspectRatio: false,
                  // legend:{
                  //   display:true,
                  //   position:'right'
                  // }
                }}
              />
              :<div className="alert alert-secondary" role="alert">
                No data available
              </div>
            }
            </div>
            <div className="col-lg-4">
            {this.state.f1_score.labels !== undefined?
              <Bar
                data={this.state.f1_score}
                height={250}
                options={{
                  title:{
                    display:true,
                    text:'F1 Score (in %)',
                    fontSize:20
                  },
                  tooltips: {
                    callbacks: {
                        afterLabel: (t, d) => {
                            const index = parseInt(t.xLabel.split("_")[1]) - 1
                            console.log("INdex: ",index)
                            return this.state.scenario[parseInt(index)]
                            }
                        }
                  },
                  scales:{
                    xAxes: [{
                      barThickness : 25
                    }],
                    yAxes: [{
                      ticks: {
                          beginAtZero:true,
                          min: 0,
                          max: 100
                      }
                    }]
                  },
                  legend:{
                    display:false
                  },
                  maintainAspectRatio: false,
                  // legend:{
                  //   display:true,
                  //   position:'right'
                  // }
                }}
              />
              :<div className="alert alert-secondary" role="alert">
                No data available
              </div>
            }
            </div>

          </div>
        </div>
      </div>



    );
  }
}
//
//prop types
//
App.propTypes={
level:PropTypes.string,
run_id:PropTypes.number,
bench_id:PropTypes.number,
run_lim:PropTypes.string,
//navigateHome:PropTypes.string,
}
//
//default props
//
App.defaultProps= {
level:[],
run_id:1,
bench_id:1,
run_lim:[],
//navigateHome:[],
}
